export const mathSubjects = ["addition","subtraction","multiplication","division"] as const // do not change order
export type MathSubjects = typeof mathSubjects[number]
